import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TS1_SESSION_REMARK_MAX_LENGTH } from "../ts1-form.factories";

export type Ts1SessionRemarkModalData = {
	sessionLabel: string;
	value: string;
};

@Component({
	selector: "app-ts1-session-remark-modal",
	templateUrl: "./ts1-session-remark-modal.component.html",
	styleUrls: ["./ts1-session-remark-modal.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class Ts1SessionRemarkModalComponent {
	readonly maxLength = TS1_SESSION_REMARK_MAX_LENGTH;
	remarkControl = new FormControl("", [Validators.maxLength(this.maxLength)]);

	constructor(
		private dialogRef: MatDialogRef<Ts1SessionRemarkModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: Ts1SessionRemarkModalData,
	) {
		this.remarkControl.setValue(data?.value ?? "");
	}

	cancel(): void {
		this.dialogRef.close(null);
	}

	save(): void {
		const trimmed = (this.remarkControl.value ?? "").toString().trim().slice(0, this.maxLength);
		this.dialogRef.close(trimmed);
	}
}
